<template>
	<div class="page-container">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msgAlert"
	      md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="goToRoulette()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Registrar
				</span>
			</md-app-toolbar>
			<md-app-content>
				<div class="fundo-geral" style="height: 100%;">
					<div class="md-layout">
						<div class="md-layout-item logo">
							<img class="titan-logo" src="../assets/titan_logo.png">
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<md-field>
						      <label>Nome</label>
						      <md-input v-model="nome"></md-input>
						    </md-field>
						    <md-field>
						      <label>E-mail</label>
						      <md-input v-model="email"></md-input>
						    </md-field>
						    <md-field>
						      <label>Confirmar e-mail</label>
						      <md-input v-model="email_confirm"></md-input>
						    </md-field>
						    <md-field>
						      <label>Senha</label>
						      <md-input v-model="senha" type="password"></md-input>
						    </md-field>
						    <md-field>
						      <label>Confirmar senha</label>
						      <md-input v-model="senha_confirm" type="password"></md-input>
						    </md-field>
						    <md-field v-if="partnerId">
						      <label>Parceiro</label>
						      <md-input v-model="partnerName" readonly></md-input>
						    </md-field>
						    <div class="buttons">
								<button class="button has-background-black has-text-white is-fullwidth" v-bind:class="loadingClass()" @click="register()"><strong>CADASTRAR</strong></button>
							</div>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanClientRegister',
		data () {
			return {
				nome: "",
				email: "",
				email_confirm: "",
				senha: "",
				senha_confirm: "",
				alert: false,
			    msgAlert: "",
			    isLoading: false,
			    partnerId: null,
			    partnerName: null
			}
		},
        methods: {
        	backHome: function() {
        		this.$router.push({ name: 'TitanHome'})
        	},
        	goToClientLogin: function() {
        		this.$router.push({ name: 'TitanClientLogin'})
        	},
        	goToRoulette: function() {
        		this.$router.push({ name: 'TitanRoulette'})
        	},
			loadingClass: function() {
				return {
					'is-loading': (this.isLoading == true)
				}
			},
        	register: function() {

        		if (this.isLoading)
        			return false;

        		if (this.nome == "") {
        			this.msgAlert = "Preencha seu nome, não precisa ser completo ;)"
        			this.alert = true
        			return false;
        		}

        		if (this.email == "" || this.senha == "") {
        			this.msgAlert = "Preencha e-mail e senha."
        			this.alert = true
        			return false;
        		}

        		if (this.email != this.email_confirm) {
        			this.msgAlert = "E-mail de confirmação não coincide com o informado."
        			this.alert = true
        			return false;
        		}

        		if (this.senha != this.senha_confirm) {
        			this.msgAlert = "Senha de confirmação não coincide com a informada."
        			this.alert = true
        			return false;
        		}

        		this.isLoading = true;

        		var jsonRegister = {};
        		jsonRegister.name = this.nome
        		jsonRegister.email = this.email
        		jsonRegister.password = this.senha
        		if (this.partnerId) jsonRegister.partnerId = this.partnerId

        		var form = new FormData();
				form.append("data", JSON.stringify(jsonRegister));
				var config = {
				  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
				};

				var v = this;
				axios({
				    method: 'post',
				    url: this.$root.$data.API_URL + 'client/register',
				    data: form,
				    config: config
			    })
			    .then(function (response) {
			        // console.log(response);
		        	let result = response.data
		        	if (!(result.success)) {
		        		v.msgAlert = result.message
	        			v.alert = true
	        			v.isLoading = false
	        			return false;
		        	}

		        	v.msgAlert = 'Cadastro realizado com sucesso. Você será redirecionado para o login em alguns segundos.';
	        		v.alert = true

	        		setTimeout(() => {
					  v.goToClientLogin();
					}, "2000")

				});
        	}
        },
        created() {
        	if (this.$route.params.partnerid) this.partnerId = this.$route.params.partnerid;
        },
        mounted() {
        	if (this.partnerId) {
        		axios
				.get(this.$root.$data.API_URL + 'client/partner-info/' + this.partnerId)
				.then(response => {
					if (response.data.success) {
		        		this.partnerName = response.data.partnerName
		        	}
		        });
        	}
        }
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanClientRegister.vue